<!--线缆测温数据配置 -->
<template>
  <div class="kanban" :id="idFlag?'kanban':''">
    <!-- 头部标题 kanban2 -->
    <div class="tit">
      <!-- <img class="logo" src="./params/logo.png"> -->
      <img class="t_img" src="./params/heard.png">
      <div class="icons">
        <img src="./params/22.png" v-if="fullscreen" @click="handleFullScreen">
        <img src="./params/11.png" v-else @click="handleFullScreen">
        <img src="./params/home.png" @click="idFlag = !idFlag">
      </div>
    </div>
    <!-- 中间内容	 -->
    <div class="body">
      <div class="left">
        <div class="box_center">
          <div class="tit">单晶炉用电量(kWh)</div>
          <img src="./params/bg.png" alt="">
          <div class="chart">
            <vchart style="width: 100%;height: 100%;" ref='vchartPie'></vchart>
          </div>
        </div>
        <div class="box_center">
          <div class="tit">单晶炉负荷趋势图(kW)</div>
          <img src="./params/bg.png" alt="">
          <div class="chart">
            <vchart style="width: 100%;height: 100%;" ref='vchartPie2'></vchart>
          </div>
        </div>
        <div class="box_center">
          <div class="tit">单晶设施设备用电量(kWh)</div>
          <img src="./params/bg.png" alt="">
          <div class="chart">
            <vchart style="width: 100%;height: 100%;" ref='vchartPie3'></vchart>
          </div>
        </div>

        <!-- <img src="./params/quepian.png" alt="">
        <img src="./params/bg.png" alt=""> -->
      </div>
      <div class="medio">
        <img style="height: calc(100% - 12px);opacity: 0;" src="./params/box.png" alt="">
      </div>
      <div class="right">
        <div class="box_center">
          <div class="tit">PCW水泵用电量(kWh)</div>
          <img src="./params/bg.png" alt="">
          <div class="chart">
            <vchart style="width: 100%;height: 100%;" ref='vchartPie4'></vchart>
          </div>
        </div>
        <div class="box_center">
          <div class="tit">总负荷趋势图(kW)</div>
          <img src="./params/bg.png" alt="">
          <div class="chart">
            <vchart style="width: 100%;height: 100%;" ref='vchartPie5'></vchart>
          </div>
        </div>
        <div class="box_center">
          <div class="tit">切片设施设备用电量(kWh)</div>
          <img src="./params/bg.png" alt="">
          <div class="chart">
            <vchart style="width: 100%;height: 100%;" ref='vchartPie6'></vchart>
          </div>
        </div>
      </div>
    </div>
    <!-- 底部 -->
    <div class="footer">

      <div class="box_center">
        <div class="tit">越南晶科晶硅厂区用电量(kWh)</div>
        <img src="./params/bg2.png" alt="">
        <div class="chart">
          <vchart style="width: 100%;height: 100%;" ref='vchartPie7'></vchart>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import vchart from '@/components/module/chart/vchart.vue';
  import request from "@/api/http.js";
  export default {
    components: {
      vchart,
    },
    data () {
      return {
        idFlag: true,
        fullscreen: false,
        treeData: [],//模型配置数据
        currentTime: '',//当月1号
        img: '',
      }
    },

    mounted () {
      var date=new Date();
      date.setDate(1);
      var firstDay=date.toLocaleDateString();
      this.currentTime=new Date().getTime();//当月1号


      // 
      // areaOutfit 模型配置

      //       单晶炉用电量 DJLNH
      // PCW水泵用电量 PCWSB
      // 单晶设施设备用电量 DJSSNH
      // 切片设施设备用电量 QPSSNH
      // 单晶炉负荷趋势图 DJLFH

      //appType 类型: 36-正向有功，31-负荷
      //modelTypeEnum AREA PT
      //echartsId 
      this.getEchares(36,'DJLNH','AREA','vchartPie');  // 单晶炉用电量(kWh)
      this.getEchares(31,'DJLFH','AREA','vchartPie2');  // 单晶炉负荷趋势图(kW)
      this.getEchares(36,'DJSSNH','PT','vchartPie3');  // 单晶设施设备用电量(kWh)

      this.getEchares(36,'PCWSB','AREA','vchartPie4');  // PCW水泵用电量(kWh)
      this.ceshi('vchartPie5')  // 总负荷趋势图(kW) 
      this.getEchares(36,'QPSSNH','PT','vchartPie6');  // 切片设施设备用电量(kWh)
      this.ceshi2('vchartPie7');//根据单位查询单位绑定的设备能耗
    },
    computed: {
      nowUnit: function() {
        return this.$store.unitStore.getters.getNowUnit
      },

    },

    methods: {
      urlTo () {
        this.$store.menuStore.commit("getMenuList");
        // location.reload();
      },
      // 全屏事件
      handleFullScreen () {
        // 此处可根据获取节点进行区域全屏事件
        let element=document.getElementsByClassName('kanban')[0];
        if(this.fullscreen) {
          if(document.exitFullscreen) {
            document.exitFullscreen();
          } else if(document.webkitCancelFullScreen) {
            document.webkitCancelFullScreen();
          } else if(document.mozCancelFullScreen) {
            document.mozCancelFullScreen();
          } else if(document.msExitFullscreen) {
            document.msExitFullscreen();
          }
        } else {
          if(element.requestFullscreen) {
            element.requestFullscreen();
          } else if(element.webkitRequestFullScreen) {
            element.webkitRequestFullScreen();
          } else if(element.mozRequestFullScreen) {
            element.mozRequestFullScreen();
          } else if(element.msRequestFullscreen) {
            // IE11
            element.msRequestFullscreen();
          }
        }
        this.fullscreen=!this.fullscreen;
      },
      fullScreen () {
        var de=document.getElementById('kanban');
        if(de.requestFullscreen) {
          de.requestFullscreen();
        } else if(de.mozRequestFullScreen) {
          de.mozRequestFullScreen();
        } else if(de.webkitRequestFullScreen) {
          de.webkitRequestFullScreen();
        } else {
          this.fullScreen()
        }

      },
      // 根据单位查询单位绑定的设备能耗
      ceshi2 (id) {
        var d=[];//日期
        for(let i=1;i<31;i++) {
          d.push(i)
        }
        var option={
          grid: {
            top: 60,
            left: 70,
            right: 15,
            bottom: 31,
          },
          legend: {
            top: 25,
            icon: "rect", // 
            right: 10,
            itemWidth: 10, // 设置宽度
            itemHeight: 10, // 设置高度
            textStyle: {
              lineHeight: 56,
              fontSize: 10,
            },
            itemGap: 12, // 设置间距
          },
          tooltip: {
            trigger: "axis",
            axisPointer: {
              // Use axis to trigger tooltip
              type: "shadow", // 'shadow' as default; can also be 'line' or 'shadow'
            },
          },
          color: ['#FFDC60 ','#75CC7E','#3DA3DD','#2CBAC3','#61A768','#0D723B','#2C5E52','#738D95'],
          xAxis: {
            axisLabel: {
              textStyle: {
                fontWeight: 100,
                color: '#fff'
              },
            },
            splitLine: {
              color: ['#333'],
              //网格线
              show: false,
            },
            type: "category",
            z: 99,
            data: d,
          },
          yAxis: {
            splitLine: {
              lineStyle: {
                color: ['#333'],
                type: 'dashed'
              }
            },
            axisLabel: {
              textStyle: {
                fontWeight: 100,
                color: '#fff'
              },
            },
            type: "value",
          },
          series: [],
        }

        var params={
          currentTime: this.currentTime,
          step: 1,
          unitId: this.nowUnit.id
        }
        this.$refs[id].setData(option,true);
        request({url: "/jingke/getKeJingEnergy",method: "get",params}).then(res => {
          if(res.code=200) {
            console.log(res.data,'根据单位查询单位绑定的设备能11耗');

            res.data.map(v => {
              var d=[];
              for(const i in v.keJingEnergy) {
                d.push(v.keJingEnergy[i])
              }
              option.series.push({
                name: v.energyName,
                data: d,
                type: "bar",
                showSymbol: false,
                smooth: false,
              });

            })

            this.$refs[id].setData(option,true)
          }
        })
      },

      // 根据单位查询单位绑定的设备能耗
      ceshi (id) {
        var d=[];//日期
        for(let i=1;i<31;i++) {
          d.push(i)
        }
        var option={
          grid: {
            top: 40,
            left: 70,
            right: 15
          },
          tooltip: {
            trigger: "axis",
            axisPointer: {
              // Use axis to trigger tooltip
              type: "shadow", // 'shadow' as default; can also be 'line' or 'shadow'
            },
          },

          legend: {
            type: 'scroll',
            bottom: 17,
            icon: "rect", //  
            itemWidth: 13, // 设置宽度
            itemHeight: 8, // 设置高度
            textStyle: {
              lineHeight: 56,
              fontSize: 10,
            },
            itemGap: 12, // 设置间距
          },
          color: ['#43c4ad','#47FF9C','#00B98D','#2CBAC3','#61A768','#0D723B','#2C5E52','#738D95'],
          xAxis: {
            boundaryGap: false,
            axisLabel: {
              textStyle: {
                fontWeight: 100,
                color: '#fff'
              },
            },
            splitLine: {
              color: ['#333'],
              fontWeight: 200,
              //网格线
              show: false,
            },
            type: "category",
            z: 99,
            data: d,
          },
          yAxis: {
            splitLine: {
              lineStyle: {
                color: ['#333'],
                type: 'dashed'
              }
            },
            axisLabel: {
              textStyle: {
                fontWeight: 100,
                color: '#fff'
              },
            },
            type: "value",
          },
          series: [],
        }

        var params={
          currentTime: this.currentTime,
          step: 1,
          unitId: this.nowUnit.id
        }

        this.$refs[id].setData(option,true)
        request({url: "/jingke/getKeJingLoad",method: "get",params}).then(res => {
          if(res.code=200) {
            console.log(res.data,'总负荷趋势图');
            var d=[];
            var index=0
            for(const i in res.data.keJingLoad) {
              index++
              d.push(res.data.keJingLoad[i])
            }
            if(index) {
              option.xAxis.data.length=index;
            }
            option.series.push({
              name: '总负荷趋势图',
              data: d,
              type: "line",

              areaStyle: {
                color: {
                  type: 'linear',
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [  // 渐变颜色
                    {
                      offset: 0,
                      color: '#43c4ad50',
                    },
                  ],
                  global: false,
                },
              },
              stack: "total",
              showSymbol: false,
              smooth: true,
            });

            this.$refs[id].setData(option,true)
          }
        })
      },
      // 通过名称 递归获取id
      digui (arr,name) {
        var d=''
        for(let i=0;i<arr.length;i++) {
          const a=arr[i];
          if(a.modelName==name) {
            d=a.id
            break
          }
          if(a.children&&a.children.length) {
            var b=this.digui(a.children,name);
            if(b) {
              d=b
            }
          }
        }
        return d
      },
      // 单晶炉用电量(kWh)
      getEchares (appType,modelCode,modelTypeEnum,id) {
        var d=[];//日期
        for(let i=1;i<31;i++) {
          d.push(i)
        }
        var option={
          grid: {
            top: 40,
            right: 15,
            left: 70,
          },
          tooltip: {
            trigger: "axis",
            axisPointer: {
              // Use axis to trigger tooltip
              type: "shadow", // 'shadow' as default; can also be 'line' or 'shadow'
            },
          },

          legend: {

            type: 'scroll',
            pageIconColor: '#47ff5a',
            pageIconSize: 10,
            pageTextStyle: {
              color: '#636f68'
            },
            bottom: 17,
            icon: "rect", //  
            itemWidth: 13, // 设置宽度
            itemHeight: 8, // 设置高度 
            textStyle: {
              lineHeight: 56,
              fontSize: 10,
            },
            itemGap: 12, // 设置间距
          },
          color: ['#FFA149','#47FF9C','#FF6939','#2CBAC3','#616CA7','#0D723B','#2C68C3','#738D95'],
          xAxis: {
            boundaryGap: false,
            axisLabel: {
              textStyle: {
                fontWeight: 100,
                color: '#fff',
                fontWeight: 100,
              },
            },
            splitLine: {
              color: ['#333'],

              //网格线
              show: false,
            },
            type: "category",
            z: 99,
            data: d,
          },
          yAxis: {
            splitLine: {
              lineStyle: {
                color: ['#333'],
                type: 'dashed'
              }
            },
            axisLabel: {
              textStyle: {
                fontWeight: 100,
                color: '#fff'
              },
            },
            type: "value",
          },
          series: [],
        }


        // 类型: 36-正向有功，31-负荷
        var params={
          appType,
          currentTime: this.currentTime,
          modelCode,
          modelTypeEnum,
          step: 1,
        };
        this.$refs[id].setData(option,true)
        request({url: "/jingke/getKeJingEnergyOrLoad",method: "get",params}).then(res => {

          if(res.code=200) {
            res.data.map((v,ii) => {
              var d=[];
              var index=0;
              for(const i in v.keJingEnergy) {
                index++;
                d.push(v.keJingEnergy[i]);
              }
              if(index) {
                option.xAxis.data.length=index;
              }
              option.series.push({
                name: v.energyName,
                data: d,
                type: "line",
                areaStyle: {
                  color: new echarts.graphic.LinearGradient(0,0,0,1,[
                    {
                      offset: 0,
                      color: option.color[ii]+50
                    },

                  ])
                },
                stack: "total",
                showSymbol: false,
                smooth: true,
              });

            })

            this.$refs[id].setData(option,true)
          }
        })

      },
    },

  }
</script>
<style scoped>
  .icons {
    position: absolute;
    right: 10px;
    top: 24px;
  }

  .icons img {
    margin-left: 15px;
  }

  #kanban {
    width: 100%;
    position: fixed;
    top: 0;
    margin: 0;
    left: 0;
    right: 0;
    bottom: 0;
    height: 100% !important;
    z-index: 10;
  }

  .box_center {
    position: relative;
  }

  .box_center .tit {
    position: absolute;
    /* background: linear-gradient(180deg, #FFFFFF 0%, #62AC91 100%); */
    font-size: 15px;
    padding-top: 4px;
    text-align: center;
    font-weight: normal;
    /* background-image: linear-gradient(180deg, #FFFFFF 0%, #62AC91 100%); */
    /* -webkit-background-clip: text;
    -webkit-text-fill-color: transparent; */
    color: #fff;
    font-family: 'fangsong';
  }

  .kanban>.tit>.logo {
    position: absolute;
    left: 10px;
    top: 8px;
    width: 110px;
  }



  .box_center .chart {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }

  .footer img {
    width: 100%;
  }

  .kanban {
    width: 100%;
    background: url(./params/bgc.png) no-repeat;
    padding-top: 0 !important;
    background-size: 100% 100%;
    background-attachment: fixed;
    position: relative;
  }

  .kanban .tit {
    margin-top: 10px;
    width: 100%;
  }

  .kanban .tit .t_img {
    width: 96%;
    margin-bottom: 4px;
  }

  .body {
    display: flex;
  }

  .body img {
    width: 100%;
  }

  .body .left {
    width: 25%;
  }

  .body .left img {
    margin-bottom: 12px;
  }

  .body .medio {
    flex: 1;
  }

  .body .right {
    width: 25%;
  }

  .body .right img {
    margin-bottom: 12px;
  }
</style>